// extracted by mini-css-extract-plugin
export default {"avisoCookie":"AvisoCookie_avisoCookie__mh8rN"};